import { ReactNode, Suspense } from 'react';

type TTenantTheme = {
  cssFiles?: string[];
  isThemeDisabled?: boolean;
  children: ReactNode;
};

/**
 * Configure tenant styles
 */
const TenantTheme = ({
  children,
  isThemeEnabled,
  cssFiles,
}: {
  children: ReactNode;
  isThemeEnabled: boolean;
  cssFiles?: string[];
}) => {
  return (
    <>
      <Suspense fallback={<></>}>
        {isThemeEnabled && <Theme cssFiles={cssFiles} />}
      </Suspense>
      {children}
    </>
  );
};

const Theme = ({ cssFiles }: Pick<TTenantTheme, 'cssFiles'>) => {
  cssFiles?.forEach((cssFile) => {
    import(`./${cssFile}`);
  });
  return null;
};

export default TenantTheme;
